/**
 * @author Daniel Aguirre
 * @file routes.js
 * @description Patient events routes
 */

// Pages
import EventReportTypes from '@nephro/pages/PatientEvents/Components/EventReportTypes';
import EventReportForm from '@nephro/pages/PatientEvents/Components/EventReportForm';
import EventReportEdit from '@nephro/pages/PatientEvents/Components/EventReportEdit';
import PatientEvents from '@nephro/pages/PatientEvents';

const pathStart = '/main/events';
const routes = [
  {
    path: `${pathStart}/`,
    isProtected: true,
    component: PatientEvents,
    exact: true
  },
  {
    path: `${pathStart}/eventTypes`,
    isProtected: true,
    component: EventReportTypes,
    exact: true
  },
  {
    path: `${pathStart}/form`,
    isProtected: true,
    component: EventReportForm,
    exact: true
  },
  {
    path: `${pathStart}/edit/:id`,
    isProtected: true,
    component: EventReportEdit,
    exact: true
  },
  { redirect: true, to: `${pathStart}/` }
];

export default routes;
